import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxsModule } from '@ngxs/store';
import { WorkSplitState } from './work-split.state';

@NgModule({
  imports: [CommonModule, NgxsModule.forFeature([WorkSplitState])],
  declarations: []
})
export class WorkSplitStoreModule {}
